import { render, staticRenderFns } from "./ParticipationByWilaya.vue?vue&type=template&id=2c40b404"
import script from "./ParticipationByWilaya.vue?vue&type=script&lang=js"
export * from "./ParticipationByWilaya.vue?vue&type=script&lang=js"
import style0 from "./ParticipationByWilaya.vue?vue&type=style&index=0&id=2c40b404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports